/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



//     const germanLanguagePopup = document.querySelector("#langalertde");
//     console.log(germanLanguagePopup)
// if(germanLanguagePopup){
//     if(germanLanguagePopup.style.display == 'block'){
//       console.log("germany")
//       window.location.href = 'https://corellimg.co.uk';
//     } else {
//       console.log("not germany")
//     }
// }



document.addEventListener("DOMContentLoaded", function(event){

  var modal_filter_size_popup = new tingle.modal({
    footer: false,
    cssClass: ['size-chart-popup'],
    stickyFooter: false,
    closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: "Close",
  });

  modal_filter_size_popup.setContent(size_chart_images_html);
  
  jQuery('.size-popup-button').on('click', function(){
    modal_filter_size_popup.open();
  });
  
});






